import common from './common.json';
import administrators from './administrators.json';
export default {
  common,
  administrators,
};
